import { render, staticRenderFns } from "./activate.vue?vue&type=template&id=a590c292"
import script from "./activate.vue?vue&type=script&lang=js"
export * from "./activate.vue?vue&type=script&lang=js"
import style0 from "./activate.vue?vue&type=style&index=0&id=a590c292&prod&lang=scss"
import style1 from "./activate.vue?vue&type=style&index=1&id=a590c292&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports